export const option = {
  products: [
    {
      label: "All AvePoint Products",
      value: "*",
    },
    {
      label: "Administrator",
      value: "administrator",
    },
    {
      label: "All",
      value: "all",
    },
    {
      label: "AntiVirus",
      value: "antivirus",
    },
    {
      label: "Archiver",
      value: "archiver",
    },
    {
      label: "Auditor",
      value: "auditor",
    },
    {
      label: "Backup and Restore",
      value: "backup-and-restore",
    },
    {
      label: "Connector - File Share",
      value: "connector-file-share",
    },
    {
      label: "Connector - Media",
      value: "connector-media",
    },
    {
      label: "Content Manager",
      value: "content-manager",
    },
    {
      label: "Content Shield",
      value: "content-shield",
    },
    {
      label: "Deployment Manager",
      value: "deployment-manager",
    },
    {
      label: "Discovery Tool",
      value: "discovery-tool",
    },
    {
      label: "DocAve",
      value: "docave",
    },
    {
      label: "DocAve 6 Suite",
      value: "docave6-suite",
    },
    {
      label: "DocAve Online",
      value: "docave-online",
    },
    {
      label: "EMC Documentum Migrator",
      value: "emc-documentum-migrator",
    },
    {
      label: "Extender",
      value: "extender",
    },
    {
      label: "File Share Navigator",
      value: "file-share-navigator",
    },
    {
      label: "Governance Automation",
      value: "governance-automation",
    },
    {
      label: "Governance Automation Online",
      value: "governance-automation-online",
    },
    {
      label: "High Availability",
      value: "high-availability",
    },
    {
      label: "Installation",
      value: "installation",
    },
    {
      label: "Job Monitor",
      value: "job-monitor",
    },
    {
      label: "Lotus Notes Migrator",
      value: "lotus-notes-migrator",
    },
    {
      label: "Migration",
      value: "migration",
    },
    {
      label: "Office 365 Migrator",
      value: "office-365-migrator",
    },
    {
      label: "Oracle/Stellant Migrator",
      value: "oracle-stellant-migrator",
    },
    {
      label: "Replicator",
      value: "replicator",
    },
    {
      label: "Report Center",
      value: "report-center",
    },
    {
      label: "SMSP",
      value: "smsp",
    },
    {
      label: "Salesforce - Content Replicator",
      value: "salesforce-content-replicator",
    },
    {
      label: "Salesforce - Data Replicator",
      value: "salesforce-data-replicator",
    },
    {
      label: "SharePoint Migrator",
      value: "sharepoint-migrator",
    },
    {
      label: "Storage Manager",
      value: "storage-manager",
    },
    {
      label: "Upgrade",
      value: "upgrade",
    },
  ],
  productVersions: [
    {
      label: "All Product Versions",
      value: "*",
    },
    {
      label: "1.0.0.0",
      value: "1000",
    },
    {
      label: "2.0.0.0",
      value: "2000",
    },
    {
      label: "2.1.0.0",
      value: "2100",
    },
    {
      label: "3.0.0.0",
      value: "3000",
    },
    {
      label: "5.0.0.0",
      value: "5000",
    },
    {
      label: "5.1.0.0",
      value: "5100",
    },
    {
      label: "5.1.1.0",
      value: "5110",
    },
    {
      label: "5.1.2.0",
      value: "5120",
    },
    {
      label: "5.2.0.0",
      value: "5200",
    },
    {
      label: "5.2.1.0",
      value: "5210",
    },
    {
      label: "5.3.1.0",
      value: "5310",
    },
    {
      label: "5.4.1.0",
      value: "5410",
    },
    {
      label: "5.4.2.0",
      value: "5420",
    },
    {
      label: "5.5.0.0",
      value: "5500",
    },
    {
      label: "5.5.2.0",
      value: "5520",
    },
    {
      label: "5.5.3.0",
      value: "5530",
    },
    {
      label: "5.6.0.0",
      value: "5600",
    },
    {
      label: "5.6.1.0",
      value: "5610",
    },
    {
      label: "5.7.0.0",
      value: "5700",
    },
    {
      label: "5.7.1.0",
      value: "5710",
    },
    {
      label: "5.8.0.0",
      value: "5800",
    },
    {
      label: "6.0.0.0",
      value: "6000",
    },
    {
      label: "6.0.1.0",
      value: "6010",
    },
    {
      label: "6.0.2.0",
      value: "6020",
    },
    {
      label: "6.1.0.0",
      value: "6100",
    },
    {
      label: "6.1.1.0",
      value: "6110",
    },
    {
      label: "6.1.2.0",
      value: "6120",
    },
    {
      label: "6.2.0.0",
      value: "6200",
    },
    {
      label: "6.2.1.0",
      value: "6210",
    },
    {
      label: "6.2.2.0",
      value: "6220",
    },
    {
      label: "6.3.1.0",
      value: "6310",
    },
    {
      label: "6.3.2.0",
      value: "6320",
    },
    {
      label: "6.3.3.0",
      value: "6330",
    },
    {
      label: "6.4.0.0",
      value: "6400",
    },
    {
      label: "6.4.0.1",
      value: "6401",
    },
    {
      label: "6.4.0.2",
      value: "6402",
    },
    {
      label: "6.4.0.3",
      value: "6403",
    },
    {
      label: "6.5.0.0",
      value: "6500",
    },
    {
      label: "6.5.0.1",
      value: "6501",
    },
    {
      label: "6.8.0.0",
      value: "6800",
    },
    {
      label: "All",
      value: "all",
    },
  ],
  sharepointVersions: [
    {
      label: "All Sharepoint Versions",
      value: "*",
    },
    {
      label: "2003",
      value: "2003",
    },
    {
      label: "2007",
      value: "2007",
    },
    {
      label: "2010",
      value: "2010",
    },
    {
      label: "2010 SP1",
      value: "2010-sp1",
    },
    {
      label: "2013",
      value: "2013",
    },
    {
      label: "2013 SP1",
      value: "2013-sp1",
    },
    {
      label: "2016",
      value: "2016",
    },
    {
      label: "All",
      value: "all",
    },
    {
      label: "Office 365",
      value: "office-365",
    },
  ],
};
